import {
  useGetShopItemDetailQuery,
  useDeleteShopItemMutation,
} from "../features/shop/shopApiSlice";
import { decodeId } from "../utils/idObfuscator";

export const useShopItemDetail = (id) => {
  const decodedId = decodeId(id);
  const {
    data,
    isLoading,
    isError,
    error,
    refetch,
  } = useGetShopItemDetailQuery(decodedId, { skip: !decodedId });

  const [deleteShopItem, { isLoading: isDeleting }] = useDeleteShopItemMutation();

  return {
    itemDetail: data?.data?.ShopItem,
    isLoading,
    isError,
    error,
    refetch,
    deleteShopItem,
    isDeleting,
  };
};
